function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { createContext, useContext, useState } from 'react';
import cookie from 'js-cookie';
import { Mode, Theme } from './themes/types';
var MODE_KEY = 'stash-user-mode-preference';
var THEME_KEY = 'stash-user-theme-preference';

function determineModeFromDarkMql(e) {
  return e.matches ? Mode.Dark : Mode.Light;
}

var ThemePreferenceContext = /*#__PURE__*/createContext();
export function useThemePreferenceContext() {
  return useContext(ThemePreferenceContext);
}

function isValidMode(mode) {
  return Object.values(Mode).includes(mode);
}

function isValidTheme(theme) {
  return Object.values(Theme).includes(theme);
}

export function ThemePreferenceProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(cookie.get(MODE_KEY) || undefined),
      _useState2 = _slicedToArray(_useState, 2),
      userModePreference = _useState2[0],
      setUserModePreference = _useState2[1];

  var _useState3 = useState(cookie.get(THEME_KEY) || undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      userThemePreference = _useState4[0],
      setUserThemePreference = _useState4[1];

  var systemPrefersDarkQl = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && window.matchMedia('(prefers-color-scheme: dark)');

  var _useState5 = useState(determineModeFromDarkMql(systemPrefersDarkQl)),
      _useState6 = _slicedToArray(_useState5, 2),
      systemModePreference = _useState6[0],
      setSystemModePreference = _useState6[1];

  if (typeof systemPrefersDarkQl.addListener === 'function') {
    systemPrefersDarkQl.addListener(function (e) {
      var newSystemPreference = determineModeFromDarkMql(e);
      setSystemModePreference(newSystemPreference);
    });
  }

  function setModePreference(mode) {
    // allow setting undefined to "clear" the user's preference and fall back to system preference
    if (mode && !isValidMode(mode)) {
      throw Error("".concat(mode, " is not a valid mode, please use one of (").concat(Object.keys(Mode), ")"));
    }

    if (mode) {
      cookie.set(MODE_KEY, mode);
    } else {
      cookie.remove(MODE_KEY);
    }

    setUserModePreference(mode);
  }

  function setThemePreference(theme) {
    // swallow errors for 'default' for legacy codebases
    if (theme !== 'default' && !isValidTheme(theme)) {
      throw Error("".concat(theme, " is not a valid theme, please use one of (").concat(Object.keys(Theme), ")"));
    }

    if (theme) {
      cookie.set(THEME_KEY, theme);
    } else {
      cookie.remove(THEME_KEY);
    }

    setUserThemePreference(theme);
  }

  var mode = isValidMode(userModePreference) ? userModePreference : systemModePreference || Mode.Light;
  var theme = isValidTheme(userThemePreference) ? userThemePreference : Theme.Rise;
  return /*#__PURE__*/React.createElement(ThemePreferenceContext.Provider, {
    value: {
      mode: mode,
      theme: theme,
      userModePreference: userModePreference,
      userThemePreference: userThemePreference,
      setModePreference: setModePreference,
      setThemePreference: setThemePreference
    }
  }, children);
}